import type { FunctionComponent } from 'react';

import { Breadcrumbs as TamagoshiBreadcrumbs } from '@/core/tamagoshiv2/components/Breadcrumbs/Breadcrumbs';
import { useBreadcrumbs } from '@/domains/productDiscovery/ProductPage/common/components/Breadcrumbs/useBreadcrumbs';

interface Props {
  className?: string;
}

export const Breadcrumbs: FunctionComponent<Props> = ({ className }) => {
  const { levels } = useBreadcrumbs();

  if (!levels.length) return null;

  return <TamagoshiBreadcrumbs className={className} levels={levels} />;
};

Breadcrumbs.displayName = 'Breadcrumbs';
